<template>
  <rich-cell @click="showPicker">
    <span slot="title">{{title}}</span>
    <span>{{checkStatus}}</span>
    <i class="richic-arrow"></i>
  </rich-cell>
</template>

<script>
const EVENT_INPUT = 'input'
const EVENT_CANCEL = 'cancel'
export default {
  name: 'DatePicker',
  props: {
    title: {
      type: String,
      default: String
    },
    placeholder: {
      type: String,
      default: String
    },
    startDate: {
      type: Date,
      default () {
        return new Date(new Date().getFullYear() - 150, 0, 1)
      }
    },
    endDate: {
      type: Date,
      default () {
        return new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate())
      }
    },
    value: {
      type: [Date, String, Number, Array]
    }
  },
  computed: {
    checkStatus () {
      return this.value ? this.date : this.placeholder
    },
    date () {
      const time = this.value ? new Date(this.value) : new Date()
      return [time.getFullYear(), time.getMonth() + 1, time.getDate()].join('-')
    }
  },
  methods: {
    showPicker () {
      this.datePicker = this.$createDatePicker({
        title: this.title,
        min: this.startDate,
        max: this.endDate,
        value: this.value || new Date(),
        onSelect: this.selectHandle,
        onCancel: this.cancelHandle
      })
      this.datePicker.show()
    },
    selectHandle (date, selectedVal, selectedText) {
      this.$emit(EVENT_INPUT, date)
    },
    cancelHandle () {
      this.$emit(EVENT_CANCEL)
    }
  }
}

</script>

<style>
</style>
